import React from 'react'

const PartnerStars: React.FC<{ average: number }> = ({ average }) => {
  return (
    <span style={{ color: '#E5241B' }}>
      {
        [...Array(5)].map((i, star) => {
          const filled = (star + 1) <= parseInt(average.toString().split('.')[0])
          return (
            <i
              key={star}
              style={{ margin: 0, marginRight: 4 }}
              className={`${filled ? 'fa fa-star' : 'far fa-star'}`}
            />
          )
        })
      }
    </span>
  )
}

export default PartnerStars
